module.exports = __webpack_public_path__ + "df8d10fa75ae189dcf9a464152e84102.svg";